(function(){
  if(window.rlCardColorsInstalled)return;
  window.rlCardColorsInstalled=true;
  function expandColors(group,open){
    if(!group)return;
    group.setAttribute('data-expanded',open?'true':'false');
    var more=group.querySelector('.rl-card-colors__more');
    if(more){more.setAttribute('aria-expanded',open?'true':'false');more.textContent='+'+more.dataset.moreCount+' More';}
  }
  document.addEventListener('pointerover',function(event){
    if(event.pointerType==='touch')return;
    var group=event.target.closest('.rl-card-colors');
    if(group && !group.contains(event.relatedTarget))expandColors(group,true);
  });
  document.addEventListener('pointerout',function(event){
    if(event.pointerType==='touch')return;
    var group=event.target.closest('.rl-card-colors');
    if(group && !group.contains(event.relatedTarget))expandColors(group,false);
  });
  document.addEventListener('focusin',function(event){
    if(event.target.closest('.rl-card-color'))expandColors(event.target.closest('.rl-card-colors'),true);
  });
  document.addEventListener('focusout',function(event){
    var group=event.target.closest('.rl-card-colors');
    if(group && !group.contains(event.relatedTarget) && !group.matches(':hover'))expandColors(group,false);
  });
  document.addEventListener('keydown',function(event){
    if(event.key==='Escape'){var group=event.target.closest('.rl-card-colors');if(group){event.preventDefault();group.querySelector('.rl-card-colors__more')?.focus();expandColors(group,false);}}
  });
  document.addEventListener('click',function(event){
    var more=event.target.closest('.rl-card-colors__more');
    if(more){event.preventDefault();event.stopPropagation();expandColors(more.closest('.rl-card-colors'),more.getAttribute('aria-expanded')!=='true');return;}

    var button=event.target.closest('.rl-card-color');
    if(!button)return;
    event.preventDefault();event.stopPropagation();
    var group=button.closest('.rl-card-colors');
    var card=group.closest('.products');
    if(!card)return;
    group.querySelectorAll('.rl-card-color').forEach(function(b){b.setAttribute('aria-pressed',b===button?'true':'false');});
    group.querySelector('.rl-card-colors__selection').textContent=button.dataset.color+(button.dataset.available==='true'?'':' — Sold out');
    var container=card.querySelector('.product-container .grid-link');
    var unavailable=container && container.querySelector('.rl-card-no-image');
    if(container && !unavailable){unavailable=document.createElement('span');unavailable.className='rl-card-no-image';container.appendChild(unavailable);}
    if(unavailable){unavailable.textContent=button.dataset.color+' — image unavailable';unavailable.hidden=!!button.dataset.image;}
    card.querySelectorAll('.product-container .grid-link img').forEach(function(img){img.style.visibility=button.dataset.image?'':'hidden';});
    if(button.dataset.image){
      card.querySelectorAll('.product-container .grid-link img').forEach(function(img){
        img.removeAttribute('srcset');img.removeAttribute('sizes');
        img.src=button.dataset.image;
        img.setAttribute('data-src',button.dataset.image);
        img.alt=button.dataset.color;
      });
    }
    card.classList.add('rl-card-color-selected');
    card.classList.toggle('rl-card-color-unavailable',button.dataset.available!=='true');
    card.querySelectorAll('a.grid-link,a.grid-link__title').forEach(function(link){link.href=button.dataset.url;});
    var price=card.querySelector('.grid-link__org_price');
    if(price)price.textContent=button.dataset.price;
    var compare=card.querySelector('.grid-link__sale_price');
    if(!compare && button.dataset.compare && price){
      compare=document.createElement('del');compare.className='grid-link__sale_price';price.parentNode.appendChild(compare);
    }
    if(compare){compare.textContent=button.dataset.compare;compare.hidden=!button.dataset.compare;}
    card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(function(input){input.value=button.dataset.variant;});
    card.querySelectorAll('.add-cart-btn').forEach(function(add){add.setAttribute('aria-disabled',button.dataset.available==='true'?'false':'true');});
  },true);
  document.addEventListener('click',function(event){
    var add=event.target.closest('.rl-card-color-unavailable .add-cart-btn');
    if(add){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',function(event){
    if(event.target.closest('.rl-card-color-unavailable')){event.preventDefault();event.stopImmediatePropagation();}
  },true);
})();